import { render } from "./VideoCall.vue.js?vue&type=template&id=72318824!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCall.vue?vue&type=template&id=72318824"
import script from "./VideoCall.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/VideoCall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72318824"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72318824', __exports__)) {
    api.reload('72318824', __exports__)
  }
  
  module.hot.accept("./VideoCall.vue.js?vue&type=template&id=72318824!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VideoCall.vue?vue&type=template&id=72318824", () => {
    api.rerender('72318824', render)
  })

}


export default __exports__